;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';
import { Col, Container, Row } from 'reactstrap';
import { MdOutlineChevronRight } from 'react-icons/md';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import Avatar from '../Avatar';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';
import { useParams } from 'next/navigation';

type Props = {
  candidate: Candidate;
  dictionary: Partial<Dictionaries>;
};
const DashboardHeader = ({ candidate, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale } = useParams();
  return (
    <section className="mysynergie-dashboard-header bg-light py-5 mb-5">
      <Container fluid="lg" className="my-lg-4">
        <Row className="d-flex flex-column flex-md-row align-items-center align-items-md-start justify-content-between">
          <Col xs={12} md={9}>
            <Row className="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center align-items-md-start">
              <Col
                xs={{ order: 1, size: 12 }}
                md={{ order: 2, size: 8 }}
                className="d-flex flex-column justify-content-start align-items-center align-items-md-start p-0 ms-0 ms-md-2"
              >
                <div className="welcome mb-2">{capitalizeFirstLetter(formatMessage({ id: 'mysynergie_welcome' }))}</div>
                <h1 className="text-center text-md-start mb-4 mb-lg-0">
                  {candidate.firstName} <br className="d-block d-md-none" />
                  {candidate.lastName}
                </h1>
              </Col>
              <Col
                xs={{ order: 2, size: 12 }}
                md={{ order: 1, size: 'auto' }}
                className="d-flex flex-column justify-content-start align-items-center align-items-md-start mb-4 mb-md-0"
              >
                <Avatar dictionary={dictionary} header />
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={3} className="d-flex align-self-md-center justify-content-center justify-content-md-end">
            <Link
              href={`/${locale}/my-synergie/profile`}
              className="profile-link d-flex align-items-center justify-content-center justify-content-md-end"
            >
              {formatMessage({ id: 'mysynergie_goto_profile' })}
              <div className="dashboard-link-icon d-flex align-items-center justify-content-center ms-2">
                <MdOutlineChevronRight size={24} />
              </div>
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DashboardHeader;
